import { useTranslation } from 'react-i18next';

import { useUiStore } from '@/lib/ui-store';
import { cn } from '@/lib/utils';

/**
 * The EN / ع two-button switch that GEN-S1 §5, GEN-S2 §5 and the top bar all
 * share. The labels are literals by design: each names its own language in
 * that language, so neither is ever translated.
 */
export function LanguageSwitch({ className }: { className?: string }) {
  const { t } = useTranslation();
  const locale = useUiStore((s) => s.locale);
  const setLocale = useUiStore((s) => s.setLocale);

  const options = [
    { value: 'en' as const, label: 'EN' },
    { value: 'ar' as const, label: 'ع' },
  ];

  return (
    <div
      role="group"
      aria-label={t('shell.langSwitch')}
      className={cn('inline-flex items-center gap-0.5 rounded-md border border-border p-0.5', className)}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => setLocale(option.value)}
          aria-pressed={locale === option.value}
          className={cn(
            'min-w-9 rounded px-2 py-1 text-sm font-medium transition-colors',
            locale === option.value
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
